// Tanner Fry
// tannerf1101@yahoo.com
// Data on all subscription plans for app

export enum SubscriptionPlan {
	Free = 'Free',
	Base = 'Base',
	Packed = 'Packed',
}